export default __webpack_public_path__ + "static/media/save-icon.b2654fcc.svg";